<mat-expansion-panel class="rule-edit-panel">
  <mat-expansion-panel-header class="constraints-header">
    <mat-panel-title class="rule-edit-panel-title"
      ><i class="fa fa-link margin-right-15" aria-hidden="true"></i>Priority Suppliers - REQUIRED</mat-panel-title
    >
  </mat-expansion-panel-header>

  <div class="row padding-top-15" *ngIf="prioritySuppliers.length === 0">
    <div class="col-md-12 description-legend bigger-description-legend">No supplier selected.</div>
  </div>

  <app-priority-supplier-list-edit
    (saveButtonDisabled)="onDisableSaveButton($event)"
    [_prioritySuppliers]="prioritySuppliers"
  ></app-priority-supplier-list-edit>
</mat-expansion-panel>
